import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import { NetworkProvider } from './contexts/NetworkContext.js';
import { WalletContextProvider } from './contexts/WalletContext.js';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <NetworkProvider>
      <WalletContextProvider>
        <App />
      </WalletContextProvider>
    </NetworkProvider>
  </React.StrictMode>
);
